import { HelmetDexteel } from "@dexteel/mesf-core";
import { PassChangesReport } from "./components/PassChangesReport";

export const PassChangesPage = () => {
	return (
		<>
			<HelmetDexteel title="Pass Changes" />
			<PassChangesReport />
		</>
	);
};
